export const FILE_SOURCE_URI =
  'urn:replicon:object-extension-file-definition-source:file-upload';

export const LINK_SOURCE_URI =
  'urn:replicon:object-extension-file-definition-source:link';

export const LINK_DOCUMENT_SOURCE_URI = 'urn:replicon:psa-attachment-type:link';
export const FILE_DOCUMENT_SOURCE_URI =
  'urn:replicon:psa-attachment-type:binary-object';
